import { Component, Input, OnInit } from '@angular/core';
import { MatTabNavPanel } from '@angular/material/tabs';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-merchant-tabs',
  templateUrl: './merchant-tabs.component.html',
  styleUrls: ['./merchant-tabs.component.scss'],
})
export class MerchantTabsComponent implements OnInit {
  @Input() tabPanel!: MatTabNavPanel;

  navLinks: any[];
  activeLinkIndex = -1;

  constructor(private router: Router, private translate: TranslateService) {
    this.navLinks = [
      {
        label: this.translate.get('MERCHANT.BASIC.TITLE'),
        link: 'basic-data',
      },
      {
        label: this.translate.get('MERCHANT.SITES.TITLE'),
        link: 'sites',
      },
      // nem kell, amíg nem jelenítjük meg sehol
      // {
      //   label: this.translate.get('MERCHANT.MARKETING.TITLE'),
      //   link: 'marketing-data',
      // },
      // {
      //   label: this.translate.get('MERCHANT.CONTACT.TITLE'),
      //   link: 'contact-data',
      // },
    ];
  }

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.activeLinkIndex = this.navLinks.indexOf(
        this.navLinks.find((tab) => tab.link === '.' + this.router.url)
      );
    });
  }
}
